import { render, staticRenderFns } from "./UseRateInfoModal.vue?vue&type=template&id=2b4d0517"
import script from "./UseRateInfoModal.vue?vue&type=script&lang=js"
export * from "./UseRateInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports